export default function (editor, opt = {}) {
  const domc = editor.DomComponents;
  const defaultType = domc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;

  domc.addType('paginationPageSize', {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          tagName: 'div',
          icon: '<i class="wb webconnect-subtract"></i>',
          draggable: '.pagination, .pagination-number', // Can be dropped only inside `pagination` and `pagination-number` elements
          droppable: false, // Can't drop other elements inside
          isDrop: false,
          traits: [
            ...domc.getType('table').model.prototype.defaults.traits,
            {
              type: 'text',
              label: 'Page Size Options',
              name: 'page-size-options',
              value: '',
              placeholder: '5,10,20,30,40,50,100',
            },
          ],
        },
        init() {
          console.log('Pagination Page Size Component Dropped');
        },
      },
      {
        isComponent(el) {
          if (el.getAttribute && el.getAttribute('data-gjs-type') === 'paginationPageSize') {
            return {
              type: 'paginationPageSize',
            };
          }
        },
      },
    ),
    view: defaultView.extend({
      init() {},
    }),
  });
}
